import LeftGroupList from "@/components/LeftGroupList";
import api from "@/api";
import PriceCalculateImage from "@/components/subject/PriceCalculate/PriceCalculateImage";
export default {
  name: "PriceCalculateQuestionSelector",
  components: {
    PriceCalculateImage,
    LeftGroupList
  },
  data() {
    return {
      groups: [],
      groupId: null,
      questions: [],
      typeMap: {}
    };
  },
  methods: {
    onChoose(gid) {
      this.groupId = gid;
      this.fetchList();
    },
    fetchList() {
      api.getPriceCalculateByGroupId(this.groupId).then(ret => {
        this.questions = ret.list;
      });
    },
    init() {
      api.getPriceCalculateGroups().then(list => {
        this.groups = list;
        this.groupId = list[0].value;
        this.fetchList();
      });
    }
  },
  mounted() {
    this.init();
  }
};